import React from "react";
import PropTypes from "prop-types";
import {useTheme} from "../../../../theme/ThemeProvider";
import DropDownSelect from "../DropDownSelect";
import ChipDropDownBase from "../base/ChipDropDownBase";
import FlexContainer from "../../../layout/FlexContainer";
import Text from "../../../display/Text";
import {languages} from "../../../../../configuration/constants";
import {languageEnum} from "../../../../../configuration/enums";

function LanguageSelector({language, handleLanguageUpdate}) {
  const {theme} = useTheme();

  return (
    <DropDownSelect
      dropDownBase={ChipDropDownBase}
      search
      customLabel={
        <FlexContainer alignItems="center" gap={theme.spacing(1.5)}>
          <Text variant="textXS" weight="medium" color="gray700">
            {languages[language] || "N/A"}
          </Text>
        </FlexContainer>
      }
      onChange={(newValue) => handleLanguageUpdate(newValue)}
    >
      {Object.keys(languageEnum).map((lang) => (
        <FlexContainer
          key={languageEnum[lang]}
          value={languageEnum[lang]}
          label={lang}
          alignItems="center"
          gap={theme.spacing(2)}
          sx={{cursor: "pointer"}}
        >
          <Text variant="textMD" weight="medium">
            {lang}
          </Text>
        </FlexContainer>
      ))}
    </DropDownSelect>
  );
}

LanguageSelector.propTypes = {
  language: PropTypes.string,
  handleLanguageUpdate: PropTypes.func.isRequired,
};

export default LanguageSelector;
